import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { BlockUIModule } from "primeng/blockui";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { AuthService } from "../../../services/auth/auth.service";

@Component({
  selector: "app-register",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    CardModule,
    RouterLink,
    BlockUIModule
  ],
  templateUrl: "./register.component.html",
  styleUrl: "./register.component.scss",
})
export class RegisterComponent {
  email = "";
  password = "";
  confirmPassword = "";
  passwordMismatch = false;
  blockedPanel = false;

  constructor(private authService: AuthService, private router: Router) {}

  checkPasswords() {
    this.passwordMismatch = this.password !== this.confirmPassword;
  }

  register() {
    if (this.password !== this.confirmPassword) {
      this.passwordMismatch = true;
      return;
    }
    this.blockedPanel = true;
    this.passwordMismatch = false;

    this.authService
      .register(this.email, this.password)
      .then((user) => {
        console.log("User registered:", user);
      })
      .catch((error) => {
        this.blockedPanel = false;
        console.error("Registration failed:", error);
      });

      this.router.navigateByUrl("/login");
  }
  async loginWithGoogle() {
    try {
      const user = await this.authService.loginWithGoogle();
    } catch (error) {
      this.blockedPanel = false;
      console.error("Google Login Error:", error);
    }
  }
}
